import React from 'react';

import { LocationInventoryV2 } from './locationInventoryV2';

function LocationInventory() {
    return <LocationInventoryV2 />;
}

export { LocationInventory };
